import React, { useRef, useEffect, useState } from 'react';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { NavLink } from 'react-router-dom';
import music from '../Assets/mixkit-retro-arcade-casino-notification-211.mp3';
import menuMusic from '../Assets/mixkit-game-quick-warning-notification-268.mp3';
import { IconData } from './ContactInfo';
gsap.registerPlugin(useGSAP);

function Navbar() {
    const burger = useRef();

    const initialPath = `M100 0 L200 0 L200 ${window.innerHeight} L100 ${window.innerHeight} Q-100 ${window.innerHeight / 2} 100 0`;
    const targetPath = `M100 0 L200 0 L200 ${window.innerHeight} L100 ${window.innerHeight} Q100 ${window.innerHeight / 2} 100 0`;

    const [active, setactive] = useState(false);
    const toggle = () => {
        setactive(!active);
    };

    const tl = useRef();
    useGSAP(() => {
        tl.current = gsap.timeline({ paused: false })
            .to(".sidebar", {
                transform: 'translateX(0%)',
                ease: "slow(0.2,0.2,false)",
                duration: .6,
            })
            .from(".links", {
                opacity: 0,
                x: 100,
                duration: .4,
                ease: "slow(0.2,0.2,false)",
                stagger: {
                    amount: 0.2,
                },
            });
    });

    //SIDEBAR
    useEffect(() => {
        if (active) {
            tl.current.play();
        } else {
            tl.current.reverse();
        }
    }, [active]);

    //SVG CURVE
    useEffect(() => {
        if (active) {
            gsap.to('.svgCurve path', {
                attr: { d: targetPath },
                ease: "slow(0.2,0.2,false)",
                duration: 1,
            });
        } else {
            gsap.to('.svgCurve path', {
                attr: { d: initialPath },
                ease: "slow(0.2,0.2,false)",
                duration: 1,
                delay: .8
            });
        }
    }, [active]);

    const handleNavLinkClick = () => {
        setactive(false); // Close the sidebar
        if (burger.current) {
            burger.current.querySelector('input[type="checkbox"]').checked = false; // Uncheck the checkbox
        }
    };

    //sound
    const clickSound = useRef(null);

    const playSound = () => {
        if (clickSound.current) {
            clickSound.current.currentTime = 0;
            clickSound.current.play();
        }
    };

    const menuLink = useRef(null);

    const menuSound = () => {
        if (menuLink.current) {
            menuLink.current.currentTime = 0;
            menuLink.current.play();
        }
    };

    const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

    const uniqueText = (element) => {
        const originalText = element.dataset.original;
        const currentIndex = element.dataset.index;
        element.innerText = element.innerText
            .split('')
            .map((letter, index) => {
                if (index < currentIndex) {
                    return originalText[index];
                } else {
                    return letters[Math.floor(Math.random() * 26)];
                }
            })
            .join('');
    };

    const handleMouseEnter = (e) => {
        const element = e.target;
        element.dataset.original = element.innerText;
        let index = 0;
        const interval = setInterval(() => {
            element.dataset.index = index;
            uniqueText(element);
            index+=1/3;
            if (index > element.innerText.length) {
                clearInterval(interval);
            }
        }, 50);
      
    };

    const handleMouseLeave = (e) => {
        const element = e.target;
        element.innerText = element.dataset.original;
    };

    return (
        <nav className='z-50 absolute w-full '>
            <label onClick={menuSound} ref={burger} className="hamburger z-40 fixed scale-150 right-8 top-10 ">
                <input onClick={toggle} className='checked' type="checkbox" />
                <svg className='bg-black rounded-full p-1' viewBox="0 0 32 32">
                    <path className="line line-top-bottom" d="M27 10 13 10C10.8 10 9 8.2 9 6 9 3.5 10.8 2 13 2 15.2 2 17 3.8 17 6L17 26C17 28.2 18.8 30 21 30 23.2 30 25 28.2 25 26 25 23.8 23.2 22 21 22L7 22"></path>
                    <path className="line" d="M7 16 27 16"></path>
                </svg>
                <audio ref={menuLink}>
                    <source src={menuMusic} type="audio/mpeg" />
                </audio>
            </label>

            {/**SIDEBAR */}
            <div className={`sidebar fixed bg-zinc-800  top-0 right-0 h-[100vh] sm:w-[30vw] w-[100vw] transform translate-x-[150%]`}>
                <svg className='svgCurve'>
                    <path fill='#27272A' d={initialPath}></path>
                </svg>
                <div className='sm:px-8 px-6 sm:h-[95%] h-[90%] w-full flex flex-col gap-12 text-gray-400  '>
                    <h1 className='pb-8 pt-12 border-b sm:text-[1.6vw] text-lg border-zinc-600 '>NAVIGATIONS</h1>
                    <div className="flex  flex-col gap-4 sm:text-2xl text-3xl">
                        <h1 className='links' onClick={playSound}>
                            <NavLink
                                data-value="Home"
                                onMouseEnter={handleMouseEnter}
                                onMouseLeave={handleMouseLeave}
                                onClick={handleNavLinkClick}
                                to='/'
                                className='hover:text-white hover:translate-x-6 transition-all duration-500 inline-block'
                            >
                                Home
                            </NavLink>
                        </h1>
                        <h1 className='links' onClick={playSound}>
                            <NavLink
                                data-value="About"
                                onMouseEnter={handleMouseEnter}
                                onMouseLeave={handleMouseLeave}
                                onClick={handleNavLinkClick}
                                to='/about'
                                className='hover:text-white hover:translate-x-6 transition-all duration-500 inline-block'
                            >
                                About
                            </NavLink>
                        </h1>
                        <h1 className='links' onClick={playSound}>
                            <NavLink
                                data-value="Work"
                                onMouseEnter={handleMouseEnter}
                                onMouseLeave={handleMouseLeave}
                                onClick={handleNavLinkClick}
                                to='/work'
                                className='hover:text-white hover:translate-x-6 transition-all duration-500 inline-block'
                            >
                                Work
                            </NavLink>
                        </h1>
                        <h1 className='links' onClick={playSound}>
                            <NavLink
                                data-value="Contact"
                                onMouseEnter={handleMouseEnter}
                                onMouseLeave={handleMouseLeave}
                                onClick={handleNavLinkClick}
                                to='/contact'
                                className='hover:text-white hover:translate-x-6 transition-all duration-500 inline-block'
                            >
                                Contact
                            </NavLink>
                        </h1>
                        <audio ref={clickSound}>
                            <source src={music} type="audio/mpeg" />
                            Your browser does not support the audio element.
                        </audio>
                    </div>

                    <div className="socials mt-auto flex gap-5">
                        {IconData.slice(0, 5).map((item, index) => {
                            return (
                                <a onClick={handleNavLinkClick} key={index} target='_blank' href={item.link}>
                                    <i className={`sm:text-[2.5vw] text-[9vw] hover:text-white inline-block hover:scale-110 hover:-translate-y-2 transition-all duration-400 ${item.icon}`}></i>
                                </a>
                            );
                        })}
                    </div>
                </div>
            </div>
        </nav>
    );
}

export default Navbar;